import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Copy, Flex, Box, Button } from '@elparking/components'

import CreditCard from 'commons/js/ui/CreditCard'

const PaymentMehodInfo = ({
    creditCard,
    title,
    color,
    fontWeight,
    fontSize,
    onChangePaymentMehod,
}) => (
    <Box>
        <Copy padding='0 0 10px 0' transform='uppercase' fontSize='small' fontWeight='medium'>
            {title}
        </Copy>
        <Flex justifyContent='space-between' w='100%' mb='10px'>
            <CreditCard fontWeight={fontWeight} fontSize={fontSize} color={color} brand={creditCard.brand} numbers={creditCard.lastNumbers} />
            {onChangePaymentMehod && <Button.unstyled padding='0 0 0 10px' fontSize='xSmall' onClick={onChangePaymentMehod} dataTest='change-payment-method-button'>
                <FormattedMessage defaultMessage='Cambiar' />
            </Button.unstyled>}
        </Flex>
    </Box>
)

PaymentMehodInfo.propTypes = {
    title: PropTypes.node.isRequired,
    color: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string,
    creditCard: PropTypes.shape({
        brand: PropTypes.string,
        lastNumbers: PropTypes.any,
    }).isRequired,
    onChangePaymentMehod: PropTypes.func,
}

export default PaymentMehodInfo
